var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_96_3129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8137 20.3407L34.7773 0.185547L14.0905 18.1012L20.8137 20.3407Z",
    fill: "url(#paint0_radial_96_3129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.126953 15.2219L6.33298 16.8215V21.6203L10.4703 16.8215L34.7773 0.185547L0.126953 15.2219Z",
    fill: "url(#paint1_radial_96_3129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33298 21.6203L14.0905 18.1012L34.7773 0.185547L10.4703 16.8215L6.33298 21.6203Z",
    fill: "#8e44ad"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_96_3129",
    x: 0.126953,
    y: 0.185547,
    width: 41.0233,
    height: 27.8075,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.18646,
    dy: 3.18646
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.59323
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#A6539D",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_96_3129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_96_3129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_96_3129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.44303 5.54425) rotate(41.8037) scale(23.4741 24.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6539D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_96_3129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.44303 5.54425) rotate(41.8037) scale(23.4741 24.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6539D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.599b29ab1c74ed9e7696ae3be1ac9243.svg";
export { ForwardRef as ReactComponent };